import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import MeetingHistory from "@/pages/MeetingHistory";
import CreateMeeting from "@/pages/CreateMeeting";
import MeetingDetail from "@/pages/MeetingDetail";
import AdminPanel from "@/pages/AdminPanel";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><MeetingHistory /></ProtectedRoute>} />
              <Route path="/new" element={<ProtectedRoute><CreateMeeting /></ProtectedRoute>} />
              <Route path="/meetings/:id" element={<ProtectedRoute><MeetingDetail /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
